import React from "react";
import styled from "styled-components";

const LabelDiv = styled.div`
	font-family: Visby CF;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	color: #18191b;
	margin-bottom: 1rem;
	margin-top: 2rem;
`;

function Label({ ...props }) {
	return <LabelDiv>{props.text}</LabelDiv>;
}

export const IncidentLabel = styled.div`
	font-family: Visby CF;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	color: #18191b;
	margin-bottom: 1rem;
	margin-top: 1rem;
`;

export default Label;
